import React from 'react'
import { useOrganization } from '@/contexts/OrganizationContext'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Building2 } from 'lucide-react'

const OrgSettings: React.FC = () => {
  const { currentOrg, orgRole } = useOrganization()

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Organization Settings</h1>
        <p className="text-sm text-slate-500 mt-1">Manage your organization details and preferences</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Organization Details</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-slate-500">Name</label>
              <p className="text-slate-900">{currentOrg?.name || '—'}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-slate-500">Slug</label>
              <p className="text-slate-900">{currentOrg?.slug || '—'}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-slate-500">Status</label>
              <p className="text-slate-900 capitalize">{currentOrg?.status || '—'}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-slate-500">Your Role</label>
              <p className="text-slate-900 capitalize">{orgRole?.replace('org_', '') || '—'}</p>
            </div>
          </div>

          {currentOrg?.description && (
            <div>
              <label className="text-sm font-medium text-slate-500">Description</label>
              <p className="text-slate-900">{currentOrg.description}</p>
            </div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardContent className="py-12 text-center">
          <Building2 className="w-12 h-12 text-slate-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-slate-700">Advanced Settings</h3>
          <p className="text-sm text-slate-500 mt-1">
            Organization branding, configuration, and advanced settings will be available in a future update.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}

export default OrgSettings
